<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content [innerHtml]="data.content">
</mat-dialog-content>

<mat-dialog-actions>
  <button *ngIf="data.confirmLabel" mat-button (click)="confirm()">{{ data.confirmLabel }}</button>
  <button *ngIf="data.dismissLabel" mat-button (click)="dismiss()">{{ data.dismissLabel }}</button>
</mat-dialog-actions>